import { Component, Input, OnInit } from '@angular/core';

import { BookingItem } from '@fry/booking/lib/booking-items';

import { EditorBookingItemTreeStore } from '../editor-booking-item-tree/editor-booking-item-tree.store';


@Component({
    selector: 'eas-editor-booking-item-state-action',
    templateUrl: './editor-booking-item-state-action.component.html',
    styleUrls: ['./editor-booking-item-state-action.component.css'],
    standalone: false
})
export class EditorBookingItemStateActionComponent implements OnInit {
  @Input() bookingItem: BookingItem;

  constructor(
    private itemTreeStore: EditorBookingItemTreeStore
  ) {

  }

  ngOnInit() {

  }

  isPublishable() {
    return this.bookingItem.workflow.state === 'draft';
  }

  onPublish() {
    this.itemTreeStore.publish();
    return false;
  }

  isArchivable() {
    return this.bookingItem.workflow.state === 'published';
  }

  onArchive() {
    this.itemTreeStore.archive();
    return false;
  }

  isRetractable() {
    return this.bookingItem.workflow.state === 'archived';
  }

  onRetract() {
    this.itemTreeStore.retract();
    return false;
  }
}
